<template>
  <v-dialog v-model="dialogStoreManager" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title>Nhập kho ngày {{currentTime | display_date('DD-MM-YYYY')}}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg5 md5 sm5>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12 pa-0 ma-0>
                <v-checkbox label="Sử dụng máy quét mã vạch" v-model="useBarcodeReader"></v-checkbox>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 v-if="useBarcodeReader">
                <v-text-field
                  label="Mã vận đơn"
                  ref="trancode"
                  v-model="currentItem.TransactionCode"
                  class="input-group--focused"
                  :rules="requireRules"
                ></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 v-else>
                <v-autocomplete label="Mã vận đơn" ref="trancode" :items="suggestList" item-text="TransactionCode" item-value="TransactionCode"  v-model="currentItem.TransactionCode" :search-input.sync="search" class="input-group--focused" :rules="requireRules" @change="onSelectedSuggestion"></v-autocomplete>
              </v-flex>
               <v-flex lg6 md6 sm6 pa-0>
                <h-currency-input
                  v-model="currentItem.NumberOfPack"
                  :decimal="0"
                  label="Số kiện"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg6 md6 sm6 pa-0>
                <h-currency-input
                  v-model="currentItem.Weight"
                  :decimal="2"
                  label="Cân nặng (kg)"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0 px-3>
                <v-layout row wrap>
                  <v-flex lg4 md4 sm4 pr-1>
                    <h-currency-input
                      v-model="currentItem.Length"
                      :decimal="1"
                      label="Dài (cm)"
                      class="input-group--focused"
                      @press_enter="manualChanged"
                    ></h-currency-input>
                  </v-flex>
                  <v-flex lg4 md4 sm4 px-1>
                    <h-currency-input
                      v-model="currentItem.Width"
                      :decimal="1"
                      label="Rộng (cm)"
                      class="input-group--focused"
                      @press_enter="manualChanged"
                    ></h-currency-input>
                  </v-flex>
                  <v-flex lg4 md4 sm4 pl-1>
                    <h-currency-input
                      v-model="currentItem.Height"
                      :decimal="1"
                      label="Cao (cm)"
                      class="input-group--focused"
                      @press_enter="manualChanged"
                    ></h-currency-input>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeShip"
                  :decimal="1"
                  label="Phí ship"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeFragileGoods"
                  :decimal="1"
                  label="Phí gia cố"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <h-currency-input
                  v-model="currentItem.FeeOther"
                  :decimal="1"
                  label="Phí khác"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></h-currency-input>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-textarea
                  v-model="currentItem.OrderNote"
                  label="Ghi chú"
                  class="input-group--focused"
                  @press_enter="manualChanged"
                ></v-textarea>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <input
                  ref="transactionImageInput"
                  type="file"
                  accept="image/*"
                  multiple
                  style="display: none"
                  @change="handleImageUpload"
                />
                <div class="transaction-image-panel">
                  <div class="transaction-image-panel__header">
                    <span>Ảnh mã vận đơn</span>
                    <v-btn
                      small
                      color="primary"
                      :loading="uploadingImages"
                      :disabled="uploadingImages || currentImages.length >= 3"
                      @click="$refs.transactionImageInput.click()"
                    >
                      <v-icon left small>cloud_upload</v-icon>
                      Tải ảnh
                    </v-btn>
                  </div>
                  <div class="transaction-image-panel__hint">Tối đa 3 ảnh, upload lên R2.</div>
                  <div v-if="currentImages.length" class="transaction-image-list">
                    <div v-for="(image, index) in currentImages" :key="`${image}-${index}`" class="transaction-image-item">
                      <img :src="proxyImage(image)" class="transaction-image-thumb" @click="openImage(image)" />
                      <v-btn icon x-small class="transaction-image-remove" @click="removeCurrentImage(index)">
                        <v-icon x-small>fa-times</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-flex>
              <v-flex lg12 md12 sm12 offset-md-10 pa-0>
                <v-btn @click="manualChanged">Nhập</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg7 md7 sm7>
            <v-layout pl-4 pr-2 pt-12>
              <v-flex lg12 md12 sm12>
                <v-data-table
                  :headers="headers"
                  :items="items"
                  :options.sync="pagination"
                  :server-items-length="total_rows"
                  :footer-props="items_per_page"
                  :must-sort="true"
                  :loading="loading"
                  :mobile-breakpoint="100"
                >
                  <template v-slot:item="{ item }">
                    <tr v-bind:class="{ 'warning-line': item.IsFragileGoods || item.IsCheck || item.OrderGuarantee}">
                      <td>{{ item.ID }}</td>
                      <td>{{ item.TransactionCode }}</td>
                      <td>
                        {{ item.IsFragileGoods ? 'Đóng gỗ' : '' }}
                        <br v-if="item.IsFragileGoods" />
                        {{ item.IsCheck ? 'Kiểm hàng' : '' }}
                        <br v-if="item.IsCheck" />
                        {{ item.OrderGuarantee ? 'Bảo hiểm' : '' }}
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.Weight"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.Weight | currency('', 2) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Weight"
                              :decimal="2"
                              label="Cân nặng (kg)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.NumberOfPack"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.NumberOfPack }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.NumberOfPack"
                              :decimal="0"
                              label="Số kiện"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.Length"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.Length | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Length"
                              :decimal="1"
                              label="Dài (cm)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.Width"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.Width | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Width"
                              :decimal="1"
                              label="Rộng (cm)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.Height"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.Height | currency('', 1) }}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.Height"
                              :decimal="1"
                              label="Cao (cm)"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeShip"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.FeeShip | currency('¥', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.FeeShip"
                              :decimal="1"
                              label="Phí ship"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeFragileGoods"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.FeeFragileGoods | currency('¥', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.FeeFragileGoods"
                              :decimal="1"
                              label="Phí gia cố"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-end">
                        <v-edit-dialog
                          :return-value.sync="item.FeeOther"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <div>{{ item.FeeOther | currency('¥', 1)}}</div>
                          <template v-slot:input>
                            <h-currency-input
                              v-model="item.FeeOther"
                              :decimal="1"
                              label="Phí khác"
                              autofocus
                            ></h-currency-input>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td>
                        <div v-if="getImageList(item).length" class="table-image-list">
                          <img
                            v-for="(image, index) in getImageList(item)"
                            :key="`${item.ID}-${index}`"
                            :src="proxyImage(image)"
                            class="table-image-thumb"
                            @click="openImage(image)"
                          />
                        </div>
                      </td>
                      <td class="truncate">
                        <v-edit-dialog
                          :return-value.sync="item.OrderNote"
                          large
                          lazy
                          persistent
                          @save="saveItem(item)"
                        >
                          <v-tooltip top absolute right offset-overflow max-width="250" color="light-green lighten-5 black--text">
                            <template v-slot:activator="{ on }">
                                <span v-on="on">{{ item.OrderNote }}</span>
                            </template>
                            <span>{{ item.OrderNote }}</span>
                          </v-tooltip>
                          <template v-slot:input>
                            <v-textarea
                              v-model="item.OrderNote"
                              label="Ghi chú"
                              autofocus
                            ></v-textarea>
                          </template>
                        </v-edit-dialog>
                      </td>
                      <td class="text-center">
                        <v-icon small @click="deleteItem(item.ID)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import _ from "lodash";
import moment from "moment";
import { getCurrentTime, parseImageList, proxyImage } from "@/commons/utils";

const createDefaultCurrentItem = () => ({
  ID: 0,
  TransactionCode: "",
  NumberOfPack: 1,
  FeeShip: 0,
  FeeFragileGoods: 0,
  FeeOther: 0,
  Weight: 0,
  Length: 0,
  Width: 0,
  Height: 0,
  OrderNote: "",
  StoreCNImages: []
});

export default {
  name: "store-popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 8;
    return {
      currentSessionID: '',
      useBarcodeReader: false,
      lastTransactionCode: '',
      currentItem: createDefaultCurrentItem(),
      loadingTransactionInfo: false,
      filterData: [
        {
          column: "SessionID",
          value: "",
          condition: "s_equal"
        }
      ],
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Mã vận đơn",
          value: "TransactionCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Cảnh báo",
          sortable: false,
          filterable: false,
        },
        {
          text: "Cân nặng (kg)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Số kiện",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Dài (cm)",
          value: "Length",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Rộng (cm)",
          value: "Width",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Cao (cm)",
          value: "Height",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí ship",
          value: "FeeShip",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí gia cố",
          value: "FeeFragileGoods",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Phí khác",
          value: "FeeOther",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Ảnh",
          value: "StoreCNImages",
          sortable: false,
          filterable: false
        },
        {
          text: "Ghi chú",
          value: "OrderNote"
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      pagination: configPaging,
      items_per_page: { "items-per-page-options": [8] },
      currentTime: getCurrentTime(),
      uploadingImages: false
    };
  },
  props: ["dialogStoreManager"],
  watch: {
    dialogStoreManager() {
      if (this.dialogStoreManager) {
        this.currentSessionID = this.generateUUID();
        this.filterData[0].value = this.currentSessionID;
        this.currentItem = this.getDefaultCurrentItem();
        this.getListData();
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    }
  },
  computed: {
    ...mapState({
      items: state => state.orderTransaction.listOfDay.data,
      suggestList: state => state.orderTransaction.suggestList.data,
      total_rows: state => state.orderTransaction.listOfDay.total,
      loading: state => state.orderTransaction.loading
    }),
    currentImages() {
      return this.getImageList(this.currentItem);
    }
  },
  methods: {
    proxyImage,
    getDefaultCurrentItem() {
      return createDefaultCurrentItem();
    },
    normalizeTransactionItem(item = {}) {
      return {
        ...this.getDefaultCurrentItem(),
        ...item,
        TransactionCode: item.TransactionCode || "",
        NumberOfPack: item.NumberOfPack || 1,
        FeeShip: item.FeeShip || 0,
        FeeFragileGoods: item.FeeFragileGoods || 0,
        FeeOther: item.FeeOther || 0,
        Weight: item.Weight || 0,
        Length: item.Length || 0,
        Width: item.Width || 0,
        Height: item.Height || 0,
        OrderNote: item.OrderNote || "",
        StoreCNImages: this.getImageList(item)
      };
    },
    resetCurrentItem() {
      this.currentItem = this.getDefaultCurrentItem();
    },
    getEditableFieldSnapshot(item = {}) {
      return {
        NumberOfPack: item.NumberOfPack || 1,
        FeeShip: item.FeeShip || 0,
        FeeFragileGoods: item.FeeFragileGoods || 0,
        FeeOther: item.FeeOther || 0,
        Weight: item.Weight || 0,
        Length: item.Length || 0,
        Width: item.Width || 0,
        Height: item.Height || 0,
        OrderNote: item.OrderNote || "",
        StoreCNImages: this.getImageList(item)
      };
    },
    buildStoreCnPayload(item = {}, extraData = {}) {
      return {
        TransactionCode: (item.TransactionCode || "").trim(),
        NumberOfPack: item.NumberOfPack || 1,
        FeeShip: item.FeeShip || 0,
        FeeFragileGoods: item.FeeFragileGoods || 0,
        FeeOther: item.FeeOther || 0,
        Weight: item.Weight || 0,
        Length: item.Length || 0,
        Width: item.Width || 0,
        Height: item.Height || 0,
        OrderNote: item.OrderNote || "",
        StoreCNImages: JSON.stringify(this.getImageList(item)),
        TransactionView: "store_cn_popup",
        ...extraData
      };
    },
    closePopup() {
      this.$emit("closePopup");
    },
    deleteItem(id) {
      this.$emit("deleteItem", id);
    },
    saveItem(item) {
        this.$store.dispatch("orderTransaction/setDetail", {
          data: this.buildStoreCnPayload(item),
          param: {
            pagination: this.pagination,
            filter: this.filterData,
            quickFilter: []
          },
          id: item.ID
        });
    },
    async onSelectedSuggestion() {
      await this.loadTransactionInfo(this.currentItem.TransactionCode);
    },
    manualChanged() {
      if (this.currentItem.TransactionCode !== "") {
        this.appendTransactionCode();
      }
    },
    codeChanged() {
      if (this.currentItem.TransactionCode !== "" && this.useBarcodeReader) {
        this.appendTransactionCode();
      }
    },
    appendTransactionCode: _.debounce(
      async function() {
        const transactionCode = (this.currentItem.TransactionCode || "").trim();
        if (!transactionCode) {
          return;
        }

        try {
          await this.loadTransactionInfo(transactionCode, { preserveEditableFields: true });
          this.lastTransactionCode = transactionCode;
          await this.$store.dispatch("orderTransaction/setDetail", {
            data: this.buildStoreCnPayload(this.currentItem, {
              TransactionCode: transactionCode,
              Status: configs.PACKAGE_STATUS_ENUM.DA_VE_TQ,
              StoreCNImportDate: moment().format('YYYY-MM-DD HH:mm:ss'),
              SessionID: this.currentSessionID
            }),
            param: {
              pagination: this.pagination,
              filter: this.filterData,
              quickFilter: []
            },
            id: this.currentItem.ID
          });
          const lastItem = _.find(this.items, {'TransactionCode': this.lastTransactionCode});
          if(lastItem && (lastItem.IsFragileGoods || lastItem.IsCheck || lastItem.OrderGuarantee)) {
            this.playSound('/fire_alarm.mp3');
          }
          this.$store.dispatch("orderTransaction/getListSuggest", {filter: [{
              column: "Status",
              value: [0,1],
              condition: "in",
            }]});
        } catch (err) {
          // Warehousing failed
        } finally {
          this.resetCurrentItem();
          this.$nextTick(() => this.$refs.trancode.focus());
        }
      },
      100,
      {
        leading: false,
        trailing: true
      }
    ),
    getListData() {
      var param = {
        pagination: this.pagination,
        filter: this.filterData,
        quickFilter: []
      };
      this.$store.dispatch("orderTransaction/getListOfDay", param);
      this.$store.dispatch("orderTransaction/getListSuggest", {filter: [{
          column: "Status",
          value: [0,1],
          condition: "in",
        }]});
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    async loadTransactionInfo(transactionCode, options = {}) {
      const normalizedCode = (transactionCode || "").trim();
      if (!normalizedCode) {
        this.resetCurrentItem();
        return null;
      }

      const editableSnapshot = options.preserveEditableFields
        ? this.getEditableFieldSnapshot(this.currentItem)
        : null;

      const localItem = _.find(this.suggestList, { TransactionCode: normalizedCode });
      if (localItem) {
        this.currentItem = {
          ...this.normalizeTransactionItem(localItem),
          ...(editableSnapshot || {})
        };
        return localItem;
      }

      this.loadingTransactionInfo = true;
      try {
        const ret = await this.$store.dispatch("orderTransaction/getListByFilter", [{
          column: "TransactionCode",
          value: normalizedCode,
          condition: "s_equal"
        }]);
        const remoteItem = ret && ret.data && ret.data.length ? ret.data[0] : null;
        this.currentItem = {
          ...this.normalizeTransactionItem({
            ...(remoteItem || {}),
            TransactionCode: normalizedCode
          }),
          ...(editableSnapshot || {})
        };
        return remoteItem;
      } finally {
        this.loadingTransactionInfo = false;
      }
    },
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },
    getImageList(item) {
      return parseImageList(item && item.StoreCNImages).slice(0, 3);
    },
    openImage(url) {
      if (!url) {
        return;
      }
      window.open(url, "_blank");
    },
    removeCurrentImage(index) {
      const images = [...this.currentImages];
      images.splice(index, 1);
      this.currentItem = {
        ...this.currentItem,
        StoreCNImages: images
      };
    },
    handleImageUpload(e) {
      const selectedFiles = Array.from(e.target.files || []);
      if (!selectedFiles.length) {
        return;
      }

      const availableSlots = 3 - this.currentImages.length;
      if (availableSlots <= 0) {
        window.getApp.$emit("SHOW_NOTICE", "Chỉ được tải tối đa 3 ảnh.", "warning");
        this.$refs.transactionImageInput.value = "";
        return;
      }

      const files = selectedFiles.slice(0, availableSlots);
      if (selectedFiles.length > availableSlots) {
        window.getApp.$emit("SHOW_NOTICE", "Chỉ lấy 3 ảnh đầu tiên cho mã vận đơn này.", "warning");
      }

      this.uploadingImages = true;
      Promise.all(files.map(file => this.uploadSingleImage(file)))
        .then(urls => {
          this.currentItem = {
            ...this.currentItem,
            StoreCNImages: [...this.currentImages, ...urls.filter(Boolean)].slice(0, 3)
          };
        })
        .catch(() => {
          window.getApp.$emit("SHOW_NOTICE", "Lỗi kết nối khi upload ảnh.", "error");
        })
        .finally(() => {
          this.uploadingImages = false;
          this.$refs.transactionImageInput.value = "";
        });
    },
    uploadSingleImage(file) {
      let formData = new FormData();
      formData.append("file", file);

      return this.$http
        .post(`${configs.API || ""}/admin/api/upload/r2/`, formData, {
          headers: { Authorization: "Bearer " + this.$store.state.authentication.token }
        })
        .then(res => {
          if (res.data.status === 200 && res.data.data && res.data.data.url) {
            return res.data.data.url;
          }

          window.getApp.$emit("SHOW_NOTICE", "Upload thất bại: " + (res.data.message || res.data.error || ""), "error");
          return "";
        });
    }
  },
  mounted() {
    this.$root.$on("REQUEST_REFRESH_DATA", this.getListData);
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_REFRESH_DATA", this.getListData);
  }
};
</script>
<style scoped>
.warning-line {
  background-color: rgba(250, 117, 117, 0.726);
}

.transaction-image-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.transaction-image-panel__hint {
  font-size: 12px;
  color: #666;
  margin-bottom: 8px;
}

.transaction-image-list,
.table-image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.transaction-image-item {
  position: relative;
  width: 72px;
  height: 72px;
}

.transaction-image-thumb,
.table-image-thumb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 6px;
  border: 1px solid #d7d7d7;
  cursor: pointer;
}

.table-image-thumb {
  width: 52px;
  height: 52px;
}

.transaction-image-remove {
  position: absolute;
  top: -8px;
  right: -8px;
  background: #fff;
}
</style>
